var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScenceSwapIcon = function SvgScenceSwapIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M23 9.953a2.814 2.814 0 0 0-2.815-2.813H9.953a2.814 2.814 0 0 0-2.814 2.813v10.233A2.814 2.814 0 0 0 9.953 23h10.232A2.814 2.814 0 0 0 23 20.186zm-1.536 0v10.233a1.28 1.28 0 0 1-1.279 1.28H9.953a1.28 1.28 0 0 1-1.28-1.28V9.953c0-.706.574-1.279 1.28-1.279h10.232c.706 0 1.28.573 1.28 1.28M6.116 13.853 3.181 16.79q.305.07.633.071h2.302zm.32-5.436L1 13.853v.194c0 .76.302 1.451.793 1.958l4.323-4.323V9.953c0-.546.115-1.067.32-1.536M11.683 1 1 11.682V8.737L8.737 1zM6.565 1H3.814A2.814 2.814 0 0 0 1 3.814v2.751zm1.852 5.437c.47-.206.99-.32 1.536-.32h1.729l4.323-4.324A2.8 2.8 0 0 0 14.047 1h-.194zm5.436-.32h3.007V3.813q0-.328-.071-.633z",
    clipRule: "evenodd"
  })));
};
export { SvgScenceSwapIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/ScenceSwapIcon.28675098.svg";